import * as React from 'react';
import './ImageGallery.css';
export class ProfilShortcut extends React.Component {
    /**
     * affichage de la photo de profil
     * @returns {JSX.Element}
     */
    render() {
        return (
            <div className="hvrbox">
                <img
                    src={require('./avatar.png')}
                    alt="Mountains"
                    className="hvrbox-layer_bottom btn-purple rounded"
                />
                <div className="hvrbox-layer_top">
                    <div className="hvrbox-text">Afficher votre profil</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/HomePage/internalComponents/ProfilShortcut.tsx